/**
 * SEO 配置 - chat (Português)
 */

export default {
    chat: {
        title: 'Chat IA - Assistente Multimodelo | WeryAI',
        description:
            'Converse com os melhores modelos de IA no WeryAI. Compare respostas lado a lado em várias janelas. Gere imagens, vídeos e música em um único espaço de trabalho.',
        keywords:
            'chat IA, assistente IA, chat multimodelo, chatbot IA, comparar modelos IA, chat IA lado a lado, alternativa GPT, espaço de trabalho IA, WeryAI',
        og_title: 'Chat IA - Assistente Multimodelo | WeryAI',
        og_description:
            'Converse com os melhores modelos de IA e compare respostas lado a lado. Gere imagens, vídeos e mais. Experimente grátis no WeryAI.',
        twitter_title: 'Chat IA - Assistente Multimodelo | WeryAI',
        twitter_description:
            'Converse com os melhores modelos de IA e compare respostas lado a lado. Gere imagens, vídeos e mais. Experimente grátis no WeryAI.',
    },
}
